export default __webpack_public_path__ + "static/media/heating.6eb5996f.png";